<template>
  <div id="modal__confirm">
    <CheckCircleIcon class="check__icon" />
    <div class="text__block">
      <div class="modal__title">{{ title }}</div>
      <div class="modal__subtitle">{{ subtitle }}</div>
    </div>
    <ButtonFullWidth
      class="modal__button"
      @click="() => $emit('click')"
    >
      <div slot="text">{{ buttonText }}</div>
    </ButtonFullWidth>
  </div>
</template>

<script>
  import CheckCircleIcon from '@/assets/icons/check-circle-icon.svg';
  import ButtonFullWidth from '@/components/buttons/button-full-width';

  export default {
    components: {
      CheckCircleIcon,
      ButtonFullWidth
    },
    props: {
      title: {
        type: String,
        default: ''
      },
      subtitle: {
        type: String,
        default: ''
      },
      buttonText: {
        type: String,
        default: ''
      }
    }
  };
</script>

<style lang="scss" scoped>
  #modal__confirm {
    display: flex;
    background-color: #fff;
    max-width: 527px;
    width: 100%;
    padding: 24px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    border: 1px solid #cfc4be;
    box-shadow: 0px 12px 17px 0px rgba(0, 0, 0, 0.14), 0px 5px 22px 0px rgba(0, 0, 0, 0.12),
      0px 7px 8px 0px rgba(0, 0, 0, 0.2);

    .check__icon {
      width: 60px;
      height: 60px;
      path {
        fill: #4caf50;
      }
    }

    .text__block {
      display: flex;
      flex-direction: column;
      gap: 8px;
      padding: 8px 0 16px;
      border-bottom: 1px solid #ece0db;
      width: 100%;

      .modal__title {
        color: #4c4541;
        font-size: 28px;
        font-weight: 600;
        line-height: 38px;
      }

      .modal__subtitle {
        color: #998f8a;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
      }
    }

    .modal__button {
      margin-top: 16px;
    }
  }
</style>
